import {
  LOGIN_BEGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  REGISTER_BEGIN,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  SET_FORM_STATUS,
} from "../utils/action";

const Login_reducer = (state, action) => {
  switch (action.type) {
    case LOGIN_BEGIN:
      return { ...state, login_loading: true };

    case LOGIN_SUCCESS:
      return {
        ...state,
        login_loading: false,
        userinfoData: action.payload,
        token: localStorage.getItem("token"), // ✅ ADD
        isLoggedIn: true,
        formStatus: localStorage.getItem("formstatus") === "1", // ✅ ADD
      };

    case LOGIN_ERROR:
      return { ...state, login_loading: false };

    case REGISTER_BEGIN:
      return { ...state, register_loading: true };

    case REGISTER_SUCCESS:
      return { ...state, register_loading: false };

    case REGISTER_ERROR:
      return { ...state, register_loading: false };
    case SET_FORM_STATUS:
      return { ...state, formStatus: action.payload };

    case LOGOUT_USER:
      return {
        ...state,
        token: "",
        userinfoData: {},
        role: "",
        isLoggedIn: false, // ✅ ADD
        formStatus: false, // ✅ ADD
      };

    default:
      return state;
  }
};

export default Login_reducer;
